import { type componentID, ComponentServiceBase } from "./component-service-base";
import propertyTemplateService from "../metaStoreService/property-template-service";

interface ComponentService extends ComponentServiceBase {
    getPropertyTemplate(componentID: componentID): PropertyTemplate;
}

/**
 * A new service has been extended from the base service to accomodate the use of product specific logics.
 * The base service is kept independent of the product specific logics to enable reuse in other places.
 * The base service is being used in fetchResources proj.
 * This service will be used in the webui only.
 */

class ComponentService extends ComponentServiceBase implements ComponentService {
    /**
     * Retrieves the property template for a given component ID.
     * @param componentID - Component ID
     */
    getPropertyTemplate(componentID: componentID): PropertyTemplate {
        this.checkIDPresent(componentID);
        return propertyTemplateService.getPropertyTemplateById(
            `Global.PROPERTYTEMPLATE.${this.getAdapter(componentID)}`
        );
    }
}

const componentService = new ComponentService();
export default componentService;
export * from "./component-service-base";
